<div
    class="progress-component"
    [ngClass]="{'online-steps': steps.length > 6, 'max-four-steps': steps.length <= 4}"
    *ngIf="steps"
>
    <div class="steps">
        <div
            *ngFor="let step of steps; let i = index"
            class="step"
            placement="top"
            [ngbTooltip]="step.name"
            [ngClass]="{ 'pending': step.status === StepStatusEnum.Pending }"
        >
            <a (click)=redirectPreviousStep(step)>
                <div
                    class="step-icon"
                    [ngClass]="{'cael': brandId===BrandEnum.CAEL, 'celpip': brandId===BrandEnum.CELPIP}"
                >
                    <a *ngIf="step.status === StepStatusEnum.Completed"><span class="fa fa-check"></span>
                    </a>
                    <span
                        *ngIf="step.status === StepStatusEnum.Active || step.status === StepStatusEnum.Pending"
                        [innerHTML]="step.step"
                    ></span>
                </div>
            </a>

            <a (click)=redirectPreviousStep(step)><strong [innerHTML]="step.name"></strong></a>
            <div
                *ngIf="i === 0"
                class="block-left"
            ></div>
            <div
                *ngIf="i === steps.length - 1"
                class="block-right"
            ></div>
        </div>
        <div class="line"></div>
    </div>
</div>
